export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const ARTICLE_SLUG = "basetao-spreadsheet";

export const SUPPORTED_LANGS = ["en", "fr", "de", "es", "pt"] as const;

export type LangCode = (typeof SUPPORTED_LANGS)[number];

export const DEFAULT_LANG: LangCode = "en";

export interface Category {
  key: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20pair%20of%20clean%20white%20minimalist%20sneakers%20with%20subtle%20mint%20accents%20placed%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-shoes-01&orientation=landscape",
  },
  {
    key: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20neatly%20folded%20mint%20green%20hoodie%20sweater%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-hoodies-01&orientation=landscape",
  },
  {
    key: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20crisp%20white%20t-shirt%20neatly%20folded%20with%20a%20small%20coral%20graphic%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-tshirts-01&orientation=landscape",
  },
  {
    key: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20beige%20bomber%20jacket%20laid%20flat%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-jackets-01&orientation=landscape",
  },
  {
    key: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20folded%20beige%20chino%20pants%20and%20a%20pair%20of%20shorts%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-pants-01&orientation=landscape",
  },
  {
    key: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20minimalist%20cap%20and%20a%20cozy%20beanie%20hat%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-headwear-01&orientation=landscape",
  },
  {
    key: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20coordinated%20matching%20outfit%20set%20with%20a%20hoodie%20and%20matching%20joggers%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-sets-01&orientation=landscape",
  },
  {
    key: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20neatly%20folded%20cotton%20underwear%20and%20boxers%20in%20neutral%20tones%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-underwear-01&orientation=landscape",
  },
  {
    key: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20sport%20jersey%20t-shirt%20with%20a%20number%20print%20laid%20flat%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-jersey-01&orientation=landscape",
  },
  {
    key: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20minimalist%20accessories%20including%20a%20watch%20a%20bracelet%20and%20sunglasses%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-accessories-01&orientation=landscape",
  },
  {
    key: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20tan%20leather%20handbag%20and%20a%20canvas%20tote%20bag%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-bags-01&orientation=landscape",
  },
  {
    key: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20brown%20leather%20belt%20neatly%20coiled%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-belts-01&orientation=landscape",
  },
  {
    key: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20an%20elegant%20glass%20perfume%20bottle%20with%20a%20minimal%20label%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-perfumes-01&orientation=landscape",
  },
  {
    key: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20assorted%20small%20fashion%20accessories%20like%20socks%20a%20wallet%20and%20a%20keychain%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=600&height=450&seq=cat-other-01&orientation=landscape",
  },
];

export const LANGUAGES: { code: LangCode; labelKey: string }[] = [
  { code: "en", labelKey: "lang.en" },
  { code: "fr", labelKey: "lang.fr" },
  { code: "de", labelKey: "lang.de" },
  { code: "es", labelKey: "lang.es" },
  { code: "pt", labelKey: "lang.pt" },
];